// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_33974c2b58--tooltip--M1G81","arrow_tooltip":"_33974c2b58--arrow_tooltip--xm3aH","arrow":"_33974c2b58--arrow--QDoVo"};